import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router";
import "./SearchBar.css";

export function SearchBar() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    const trimmed = query.trim();
    if (trimmed) {
      navigate(`/batches?search=${encodeURIComponent(trimmed)}`);
    }
  }

  return (
    <form className="global-search" onSubmit={handleSubmit} role="search">
      <input
        className="global-search-input"
        type="text"
        placeholder="Search batches..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        aria-label="Search batches"
      />
    </form>
  );
}
